module.exports = __webpack_public_path__ + "static/media/inhaler.6f17e442.svg";